import { Box, Collapse, IconButton, TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import Typography from "../../typography/typography";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { Checkbox } from '@mui/material';
import { useTranslation } from "react-i18next";
import { formateValueByType } from "../../../utils/common-utility";

interface IRowProps {
    rowData: any;
    level: number;
    tableHeaders: any[];
    totalHeaders: any[];
    headers: any[];
    collapsAll: boolean;
    collapsLevel: number;
    isIncrese: boolean,
    data: any,
    rowPath: number[],
    selectedRowPaths: number[][],
    onCheckboxChange: (rowPath: number[], checked: boolean) => void;
    dataSlice: any[];
    dataIndex: number;
    enableCheckBox: boolean
    rowHeight?: string
    columnWidths?: { [key: string]: number }
}

export function DynamicRow({
    rowData,
    level = 0,
    tableHeaders,
    totalHeaders,
    headers,
    collapsAll = false,
    collapsLevel = 0,
    isIncrese,
    data,
    rowPath,
    selectedRowPaths,
    onCheckboxChange,
    // dataSlice,
    enableCheckBox,
    rowHeight,
    columnWidths = {},
}: IRowProps) {
    const [open, setOpen] = useState<boolean>(false);
    const {t}=useTranslation()

    useEffect(() => {
        if (isIncrese && collapsLevel > level) {
            setOpen(true);
        }
        if (!isIncrese && collapsLevel <= level + 2) {
            setOpen(false);
        }
    }, [collapsLevel, level, isIncrese]);

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    function getNestedValue(obj: any, path: any) {
        if (path?.name == '') {
            return ''
        }

        const formattedValue=path?.name.split('.').reduce((acc: any, key: any) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj) || (path?.name.split('.').reduce((acc: any, key: any) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj) == '0' ? '0' : '-');
        return formateValueByType({
            value: formattedValue,
            ...path
        })
    }

    const isChecked = selectedRowPaths.some(path => path.length === rowPath.length && path.every((v, i) => v === rowPath[i]));

    return (
        <>
            <TableRow sx={{ cursor: 'pointer', 
                  height: rowHeight,
                  overflow: 'hidden',
                  '&:not(:last-child) td': {
                    // borderBottom: (data?.length > 1)? 'none' : '1px solid #E5E7EB',
                },
                // Ensure last row has bottom border
                '&:last-child td': {
                    borderBottom: 'none' ,
                    borderBottomColor: 'divider',
                    borderTop: "0",
                },
                // '&:first-child td': {
                //     borderTop: 'none !important' ,
                // }
             }}>
                {tableHeaders[level]?.enableCheckbox && (
                    <TableCell
                        className="dynamic-report-row"
                        sx={{
                            paddingLeft: `8px`,
                            wordWrap: 'break-word',
                            width: '60px',
                            minWidth: '60px',
                            maxWidth: '60px',
                            overflow: 'hidden',
                        }}
                    >
                        <Checkbox
                            checked={isChecked}
                            onChange={e => onCheckboxChange(rowPath, e.target.checked)}
                            onClick={e => e.stopPropagation()}
                        />
                    </TableCell>
                )}

                {tableHeaders[level].headers.map((header: any, index: number) => {
                    if (header.joinWithLeft) return null;

                    const cellIndex = tableHeaders[level].headers.slice(index + 1).findIndex((h: any) => !h.joinWithLeft);
                    const cellsToMerge = cellIndex === -1
                        ? tableHeaders[level].headers.slice(index + 1).length + 1
                        : cellIndex + 1;
                    const colSpan = header.mergeCells ? cellsToMerge : 1;

                    // Calculate total width for merged cells
                    let totalWidth = 0;
                    const defaultWidth = 100;

                    for (let i = index; i < index + colSpan && i < headers.length; i++) {
                        const cellWidth = columnWidths[t(headers[i].label)] > 100 ? columnWidths[t(headers[i].label)] : 100;
                        totalWidth += cellWidth || defaultWidth;
                    }
                    const showData=header?.showData ? header?.showData(open) : true;
                    
                    return (
                        <TableCell
                            key={index}
                            className="dynamic-report-row"
                            colSpan={colSpan}
                            sx={{
                                paddingLeft: index === 0 ? `8px` : '16px',
                                wordWrap: 'break-word',
                                width: `${totalWidth}px`,
                                minWidth: `${totalWidth}px`,
                                maxWidth: `${totalWidth}px`,
                                height: rowHeight,
                                overflow: 'hidden'
                            }}
                        >
                            {showData && header?.isCollaps ? (
                                <Box
                                    onClick={handleToggle}
                                    sx={{
                                        paddingLeft: (level > index && index === 0) ? level * 2 : 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: header?.position ? header?.position : 'start',
                                        width: '100%',
                                        height: rowHeight,
                                        overflow: 'hidden'
                                    }}
                                >
                                    <IconButton size="small" sx={{p:0}}>
                                        {open ? <ArrowDropUpIcon sx={{ fontSize: '20px' }} /> : <ArrowDropDownIcon sx={{ fontSize: '20px' }} />}
                                    </IconButton>
                                    {header?.render ? header.render(getNestedValue(rowData, header), rowData, data) : (
                                        <Typography
                                            type="s4"
                                            weight="medium"
                                            color='theme.neutral.1000'
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {getNestedValue(rowData, header)}
                                        </Typography>
                                    )}
                                </Box>
                            ) : (
                                showData && <Box sx={{
                                    paddingLeft: (level > index && index === 0) ? level * 2 : 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: header?.position ? header?.position : 'start',
                                    width: '100%',
                                    height: rowHeight,
                                    overflow: 'hidden'
                                }}>
                                    
                                    {header?.render ? header.render(getNestedValue(rowData, header), rowData, data) : (
                                        <Typography
                                            type="s4"
                                            weight="normal"
                                            color='theme.neutral.800'
                                            sx={{
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap'
                                            }}
                                        >
                                            {getNestedValue(rowData, header)}
                                        </Typography>
                                    )}
                                </Box>
                            )}
                        </TableCell>
                    );
                })}
            </TableRow>

            {Array.isArray(rowData[tableHeaders[level + 1]?.rowKey]) && (
                <TableRow sx={{}}>
                    <TableCell
                        sx={{
                            // border:level>0?'none':'none',
                            border: '0 !important',
                            borderBottom: "0 !important"
                        }}
                        style={{ padding: 0 }}
                        colSpan={tableHeaders[level].headers.filter((h: any) => !h.joinWithLeft).length + (enableCheckBox ? 1 : 0)}
                    >
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            {rowData[tableHeaders[level + 1]?.rowKey]?.map((itemData: any, idx: number, arr: any[]) => (
                                <DynamicRow
                                    key={itemData.id || [...rowPath, idx].join('-')}
                                    rowData={itemData}
                                    level={level + 1}
                                    tableHeaders={tableHeaders}
                                    headers={headers}
                                    collapsAll={collapsAll}
                                    collapsLevel={collapsLevel}
                                    isIncrese={isIncrese}
                                    totalHeaders={totalHeaders}
                                    data={data}
                                    rowPath={[...rowPath, idx]}
                                    selectedRowPaths={selectedRowPaths}
                                    onCheckboxChange={onCheckboxChange}
                                    dataSlice={arr}
                                    dataIndex={idx}
                                    enableCheckBox={enableCheckBox}
                                    rowHeight={rowHeight}
                                    columnWidths={columnWidths}
                                />
                            ))}

                            {rowData?.total && Object.keys(rowData?.total).length > 0 && totalHeaders && (
                                <TableRow sx={{ backgroundColor: totalHeaders?.[0]?.bgColor || '#FAFAFA', }}>
                                    {enableCheckBox && (
                                        <TableCell sx={{
                                            width: '60px',
                                            minWidth: '60px',
                                            maxWidth: '60px'
                                        }} />
                                    )}

                                    {totalHeaders.map((header: any, index: number) => {
                                        if (header.joinWithLeft) return null;

                                        const cellsToMerge = totalHeaders.slice(index + 1).findIndex((h: any) => !h.joinWithLeft && h !== header) === -1
                                            ? totalHeaders.slice(index + 1)?.length + 1
                                            : totalHeaders.slice(index + 1).findIndex((h: any) => !h.joinWithLeft && h !== header) + 1;
                                        const colSpan = header.mergeCells ? cellsToMerge : 1;

                                        // Calculate merged width for totals
                                        let totalWidth = 0;
                                        for (let i = index; i < index + colSpan && i < headers.length; i++) {
                                            totalWidth += columnWidths[t(headers[i].label)] || 100;
                                        }

                                        return (
                                            <TableCell
                                                key={index}
                                                className="dynamic-report-row"
                                                colSpan={colSpan}
                                                sx={{
                                                    paddingLeft: index === 0 ? `${level * 24}px` : '16px',
                                                    width: `${totalWidth}px`,
                                                    minWidth: `${totalWidth}px`,
                                                    maxWidth: `${totalWidth}px`,
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: header?.position || 'start', width: '100%' }}>
                                                    {header?.render ? header?.render(getNestedValue(rowData, header), rowData) : (
                                                        <Typography type="s4" weight="bold" color='theme.neutral.1000'>
                                                            {getNestedValue(rowData?.total, header)}
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </TableCell>
                                        );
                                    })}
                                </TableRow>
                            )}
                        </Collapse>
                    </TableCell>
                </TableRow>
            )}
        </>
    );
}